module.exports = __webpack_public_path__ + "assets/images/template/sample-image-desktop.png?v=522c849c";